import React, { Fragment, Component } from 'react';
import { ThemeProvider, injectGlobal } from 'styled-components';
import WebFont from 'webfontloader';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import PropTypes from 'prop-types';
import { createBrowserHistory } from 'history';
import { onLoadAction } from '../state-actions/onLoadAction';
import theme from '../theme/theme';
import GATracker from '../helpers/GATracker';
import Routes from '../components/organisms/Routes/Routes';
import ScrollToTop from '../helpers/ScrollToTop';
import Loading from '../components/atoms/Loading/Loading';
import AppWrapper from './App.styled';

const history = createBrowserHistory();

const mapStateToProps = state => ({
  history: state.history,
  loading: state.loading,
});

const mapDispatchToProps = dispatch => ({
  onLoadAction: loading => dispatch(onLoadAction(loading)),
});

/* eslint-disable */
injectGlobal`
  html,
  body {
    background: #5128a6;
    font-display: swap;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  a:link,
  a:active,
  a:visited {
    text-decoration: none;
    padding: 5px;
  }

  body {    
    color: #fff;
  }

  ::selection {
    background: #404040;
    color: #f6ff56;
  }
`;
/* eslint-enable */

WebFont.load({
  google: {
    families: ['Montserrat:500,600,700'],
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.setLoading = this.setLoading.bind(this);
  }

  componentDidMount() {
    window.addEventListener('load', this.setLoading, { once: true });
  }

  setLoading() {
    const loading = false;
    const { onLoadAction } = this.props;
    setTimeout(() => {
      onLoadAction(loading);
    }, 500);
  }

  render() {
    const { loading } = this.props;

    return (
      <ConnectedRouter history={history} basename="/">
        <ThemeProvider theme={theme}>
          <Fragment>
            <AppWrapper loading={loading}>
              <ScrollToTop>
                <Route path="/" component={GATracker(Routes, {})} />
              </ScrollToTop>
            </AppWrapper>
            <Loading loading={loading} />
          </Fragment>
        </ThemeProvider>
      </ConnectedRouter>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

App.propTypes = {
  onLoadAction: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/App/App.js